import React, { FC } from "react";
import { Row, Col, Card } from "antd";

const HealthStats: FC<any> = (props) => {
  return (
    <Col span={props.size}>
      <Card className="health-stats">
        <Row>
          <Col>
            <span
              style={{ margin: "6px 15px", fontSize: "20px" }}
              className="icon icon-clipboard"
            ></span>
          </Col>
          <Col>
            <Row align="middle"><span className="f16 clr-n100">{props.name}</span><span className="f12 clr-textGreyColor" style={{marginLeft:"0.5rem"}}>({props.unit})</span></Row>
            <Row
              className={
                props.status === "R"
                  ? "f18 clr-e100 w500"
                  : props.status === "B"
                  ? "f18 w500 n125"
                  : "f18 clr-s100 w500"
              }
            >
            </Row>
            {props.value === "No Data Yet" ? <span className="f12 clr-textGreyColor">{props.value}</span> : (
              <>
                {props.value}
                <Row className="f14 clr-lightGrayColor">{props.date}</Row>
              </>
            )}
          </Col>
        </Row>
      </Card>
    </Col>
  );
};

export default HealthStats;
